import { lazy } from "react";
import { BankAccount as BankAccountIcon } from "@volt_developers/react-ui-components";
import { Route } from "../RouteModel";

const AccountList = lazy(
  () => import("./../../pages/configuration/accounts/List")
);
const AccountDetails = lazy(
  () => import("./../../pages/configuration/accounts/Details")
);
const AccountEdit = lazy(
  () => import("./../../pages/configuration/accounts/Edit")
);
const AccountCreate = lazy(
  () => import("./../../pages/configuration/accounts/Create")
);

export const accountRoutes: Route = {
  i18nName: "Bank accounts",
  path: "/configuration/accounts",
  component: AccountList,
  icon: BankAccountIcon,
  showChildrenInSidebar: false,
  can: {
    do: "list",
    on: "account",
  },
  children: [
    {
      i18nName: "Create bank account",
      path: "/configuration/accounts/create",
      component: AccountCreate,
      can: {
        do: "create",
        on: "account",
      },
    },
    {
      i18nName: "Bank account details",
      path: "/configuration/accounts/:id",
      component: AccountDetails,
      can: {
        do: "details",
        on: "account",
      },
    },
    {
      i18nName: "Edit bank account",
      path: "/configuration/accounts/:id/edit",
      component: AccountEdit,
      can: {
        do: "update",
        on: "account",
      },
    },
  ],
};
